import { Observable, observe, Scope } from 'src/3rds/cube'

@Observable
export class UserProfileScope extends Scope {
    @observe() version = 0
}